import { jsx as e, Fragment as o } from "react/jsx-runtime";
import { DarkThemeWrapperContainer as p } from "../shared/index.js";
const n = ({
  children: r,
  isActive: m
}) => /* @__PURE__ */ e(o, { children: m ? /* @__PURE__ */ e(p, { children: r }) : r });
export {
  n as DarkThemeWrapper
};
